import { useRouter } from 'next/router';

import { useRentalManagerUserPropertyMultiplexWebApiHandler_details } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { useMultiplexBuildingSessionId } from './useMultiplexBuildingSessionId';

// Backend will add listingAlias to DetailsParams in ts-rental-manager-api-client; remove this type once regenerated.
type MultiplexDetailsGetParams = {
  listingAlias?: string;
  multiplexBuildingSessionId: string;
};

export const useMultiplexDetails = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string | undefined;
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const getParams: MultiplexDetailsGetParams = {
    multiplexBuildingSessionId: multiplexBuildingSessionId ?? '',
    ...(listingAlias ? { listingAlias } : {}),
  };

  const { data, error, isFetching } = useRentalManagerUserPropertyMultiplexWebApiHandler_details(
    getParams as { multiplexBuildingSessionId: string },
    {
      enabled: enabled && Boolean(multiplexBuildingSessionId && listingAlias),
      meta: {
        tags:
          multiplexBuildingSessionId && listingAlias
            ? ['multiplexBuildingSessionDetails', multiplexBuildingSessionId, listingAlias]
            : multiplexBuildingSessionId
              ? ['multiplexBuildingSessionDetails', multiplexBuildingSessionId]
              : ['multiplexBuildingSessionDetails'],
        context: {
          api: 'useRentalManagerUserPropertyMultiplexWebApiHandler_details',
          details: 'useMultiplexDetails',
        },
      },
    },
  );

  return {
    data,
    isFetching,
    error,
  };
};
